module.exports = __webpack_public_path__ + "alec-mobile.b617d1fbfdd4865f16f6.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/images/alec-mobile.jpg
// module id = ../../../../../src/assets/images/alec-mobile.jpg
// module chunks = main